import React, { useRef } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Tooltip, Typography } from '@mui/material';
import { IoMdDownload } from "react-icons/io";
import { NotificationManager } from 'react-notifications';

const DownloadMatrixCSV = ({ fileName, matrixCategories, assignmentDetails }) => {

    const csvLinkRef = useRef(null);

    const generateData = () => {
        if (!matrixCategories || matrixCategories.length === 0) {
            return [];
        }

        const data = [];
        let quizTypeArr = ["Quiz Type"];
        let quizIDArr = ["Quiz ID"];
        let quizNameArr = ["Quiz Name"];
        let quizMatrixNo = ["Quiz No."];
        let categoryNameArr = ["Category Name"];
        let categoryRows = [];

        matrixCategories.forEach((matrixCat, index) => {
            categoryRows.push([
                matrixCat.category_name,
                ...matrixCat.columnDataArr
                    .filter((col) => col && col.quiz_type !== null && col.quiz_type !== undefined)
                    .map((col) => (col.quiz_type === 0 ? col.masteryCount : col.noOfQuestions)),
            ]);
        });

        if (assignmentDetails && assignmentDetails.length) {
            assignmentDetails.forEach((assignDetail, index) => {
                quizTypeArr.push(assignDetail.quiz_type === 0 ? "Mastery" : "Test");
                quizIDArr.push(assignDetail.quiz_id);
                quizMatrixNo.push(index + 1);
                quizNameArr.push(assignDetail.quiz_name);
            });
        }

        data.push(quizIDArr);
        data.push(quizNameArr);
        data.push(quizTypeArr);
        data.push(quizMatrixNo);
        data.push([]); // empty row
        data.push(categoryNameArr);
        data.push(...categoryRows);

        return data;
    };

    const handleDownload = () => {
        let data = generateData();
        console.debug("matrixCategories>>??", matrixCategories, assignmentDetails, data)
        if (data && data.length && csvLinkRef.current && csvLinkRef.current.link) {
            csvLinkRef.current.link.setAttribute(
                "href",
                csvLinkRef.current.buildURI(data)
            );
            csvLinkRef.current.link.click();
        } else {
            NotificationManager.error("Unable to download CSV");
        }
    }


    let disabled = true;
    if (matrixCategories && matrixCategories.length) {
        disabled = false;
    }
    return (
        <div>
            {disabled ? (
                // <Tooltip
                //     arrow
                //     placement='top'
                //     disableHoverListener={!disabled}
                //     title={
                //         <Typography color="#fff">
                //             Download the assignment matrix as a CSV file
                //         </Typography>
                //     }
                // >
                    <span>
                        <Button
                            disabled
                            variant="outlined"
                            startIcon={<IoMdDownload color="#888" />}
                        >
                            Download CSV
                        </Button>
                    </span>
                // </Tooltip>
            ) : (
                <>
                    <CSVLink
                        ref={csvLinkRef}
                        data={[]}
                        filename={`${fileName}.csv`}
                        target="_blank"
                        enclosingCharacter='"'
                        style={{ display: "none" }}
                    >
                    </CSVLink>
                    {/* <Tooltip
                        arrow
                        placement='top'
                        title={
                            <Typography color="#fff">
                                Download the assignment matrix as a CSV file
                            </Typography>
                        }
                    > */}
                        <span>
                            <Button
                                variant="outlined"
                                startIcon={<IoMdDownload color="#bb0000" />}
                                onClick={handleDownload}
                            >
                                Download CSV
                            </Button>
                        </span>
                    {/* </Tooltip> */}
                </>
            )}
        </div>

    );
};

export default DownloadMatrixCSV;
